import React, { Component } from "react";
import { Slider } from 'antd';
import { countNumDown, createTimeStr } from "utils/common";
import "./index.less";

let videoIdx = 0, time = null;
class App extends Component {
    //获取视频实例
    videoPlayer = React.createRef();

    state = {
        playing: false,
        isFullScreen: false,
        currentTime: 0,
        duration: 0,
        isSupportFullScreen: false,
        showPoint: false,
        playbackRate: '1.0',
        rateArr: ['2.0', '1.5', '1.25', '1.0'],
        showPlaybackRate: false,
        isEnd: false
    }
    //props改变
    componentWillReceiveProps(nextProps, nextState){
        if(this.props.videoUrl !== nextProps.videoUrl){
            this.initVideoStatus();
        }
    }
    getRefVideoPlayer = (callback) => {
      time && clearTimeout(time);
      if(this.props.changeVideo && this.props.changeVideo.getRefVideoPlayer && this.props.changeVideo.getRefVideoPlayer().videoPlayer) {
        let refs = this.props.changeVideo.getRefVideoPlayer();
        if(this.state.isEnd) {
          refs.videoPlayer.current.currentTime = this.props.offsetDur || 0;
          this.setState({
            isEnd: false
          });
        } else {
          refs.videoPlayer.current.currentTime = (this.props.offsetDur || 0) + this.videoPlayer.current.currentTime;
        }
        videoIdx = 0;
        typeof callback === 'function' && callback(refs.videoPlayer);
      } else {
        if(videoIdx < 10) {
          videoIdx++;
          // console.log('videoIdxPlay: ', videoIdx);
          time = setTimeout(() => {
            this.getRefVideoPlayer(callback);
          }, 200);
        }
      }
    }
    //播放器点击事件
    play = () => {
      if(this.props.noOption) return;
      const playing = this.state.playing;
      this.getRefVideoPlayer(videoPlayer => {
        if(playing){
          videoPlayer.current.pause();
        } else {
          videoPlayer.current.play();
        }
      });
    	if(this.state.playing){
    		this.videoPlayer.current.pause();
    	}else{
            typeof this.props.handlePlay === "function" && this.props.handlePlay();
    		this.videoPlayer.current.play();
    	}
    }
    // 暂停
    pause = () => {
        this.videoPlayer.current.pause();
        this.handlePause();
    };
    //canplay事件
    handleCanPlay = () => {
        //判断是否支持FullScreen
        let isSupportFullScreen = false;
        const videoElement = this.videoPlayer.current;
 		if(typeof videoElement.requestFullscreen === "function"){
 			isSupportFullScreen = true;
 		}else if(typeof videoElement.webkitRequestFullScreen === "function"){
 			isSupportFullScreen = true;
 		}else if(typeof videoElement.mozRequestFullScreen === "function"){
 			isSupportFullScreen = true;
 		}else if(typeof videoElement.msRequestFullscreen === "function"){
 			isSupportFullScreen = true;
 		}

        this.setState({
            duration: videoElement.duration,
            isSupportFullScreen
        }, () => {
          this.changeSilderColor();
        })
    	typeof this.props.handleCanPlay === "function" && this.props.handleCanPlay();
    }
    //play事件
    handlePlay = () => {
        this.setState({
            playing: true
        })
        typeof this.props.handlePlay === "function" && this.props.handlePlay();
    }
    //pause事件
    handlePause = () => {
        this.setState({
            playing: false
        })
    }
    //ended事件
    handleEnded = () => {
      this.getRefVideoPlayer(videoPlayer => {
        videoPlayer.current.pause();
      });
    	this.setState({
    		playing: false,
        isEnd: true
    	})
    	typeof this.props.handleEnded === "function" && this.props.handleEnded();
    }
    //timeupdate事件
    handleTimeUpdate = (e) => {
    	const videoElement = this.videoPlayer.current;
        const currentTime = videoElement.currentTime;
    	this.setState({
    		currentTime: currentTime
    	})
        typeof this.props.handleTimeUpdate === "function" && this.props.handleTimeUpdate(currentTime);
    }
    //下一曲
    forward = () => {
        typeof this.props.forward === "function" && this.props.forward();
 	}
    //下一曲
 	backward = () => {
        typeof this.props.backward === "function" && this.props.backward();
 	}
    //初始化视频状态
    initVideoStatus = () => {
        videoIdx = 0;
        time && clearTimeout(time);
        time = null;
        this.setState({
            playing: false,
            isEnd: false,
            duration: 0,
            currentTime: 0
        })
    }
    //进度条点击
    handleProgressClick = (e) => {
    }
    //全屏按钮
 	requestFullScreen = () => {
    	const videoElement = this.videoPlayer.current;
 		if(typeof videoElement.requestFullscreen === "function"){
 			videoElement.requestFullscreen();
 		}else if(typeof videoElement.webkitRequestFullScreen === "function"){
 			videoElement.webkitRequestFullScreen();
 		}else if(typeof videoElement.mozRequestFullScreen === "function"){
 			videoElement.mozRequestFullScreen();
 		}else if(typeof videoElement.msRequestFullscreen === "function"){
 			videoElement.msRequestFullscreen();
 		}
 	}
    //pc端鼠标移入事件
    handleMouseEnter = () => {
        const isMobile = window.navigator.userAgent.indexOf("Mobile") >=0;
        if(isMobile) return false;
        this.setState({
            showPoint: true
        })
    }
    //pc端鼠标移出事件
    handleMouseLeave = () => {
        const isMobile = window.navigator.userAgent.indexOf("Mobile") >=0;
        if(isMobile) return false;
        this.setState({
            showPoint: false
        })
    }

    changeSilderColor = () => {
      if(document.querySelector('.ant-slider-track')) {
        document.querySelector('.ant-slider-track').style.backgroundColor = this.props.themeColor || "#e81118";
      }
      if(document.querySelector('.ant-slider-handle')) {
        document.querySelector('.ant-slider-handle').style.backgroundColor = this.props.themeColor || "#e81118";
      }
    }

    changeSlider = value => {
      this.videoPlayer.current.currentTime = value ? value / 1000 : 0;
      this.getRefVideoPlayer(videoPlayer => {
        if(this.state.playing){
          videoPlayer.current.play();
        } else {
          videoPlayer.current.pause();
        }
      });
    }

    handleLoadedData = () => {
        const video = document.querySelector("video");
        // const canvas = document.createElement("canvas");
        // canvas.width = video.videoWidth;
        // canvas.height = video.videoHeight;
        // canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
        // video.setAttribute("poster", canvas.toDataURL("image/png"));
    }

    changePlaybackRateModal = () => {
        this.setState({
            showPlaybackRate: !this.state.showPlaybackRate
        })
    }

    setVideoRate = (rate) => {
        this.setState({
            playbackRate: rate,
            showPlaybackRate: false
        }, () => {
            this.videoPlayer.current.playbackRate = Number(rate);
            this.getRefVideoPlayer(videoPlayer => {
              videoPlayer.current.playbackRate = Number(rate);
            });
        })
    }

    componentDidMount() {
      this.changeSilderColor();
    }

  componentWillUnmount() {
      videoIdx = 0;
      time && clearTimeout(time);
      time = null;
    }

  render(){
    	const { playing, isFullScreen, currentTime, duration,
            isSupportFullScreen, showPoint, playbackRate, rateArr, showPlaybackRate } = this.state;
    	const { videoUrl, autoPlay, themeColor, muted, id = '', poster = '' } = this.props;
        const isMobile = window.navigator.userAgent.indexOf("Mobile") >= 0;

        return (
        	<div className="video-player-wrap"
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}>
        		<div className="video-player" style={{height: isMobile ? "2.27rem" : "258px"}}>
	        		{
                        videoUrl &&
                        <React.Fragment>
                            <video className="video-player-element"
                                id={id}
                                muted={muted || false}
                                controls={isMobile}
                                ref={this.videoPlayer}
                                object-fit="contain"
                                x5-playsinline="true"
                                playsInline={true}
                                webkit-playsinline="true"
                                x-webkit-airplay="allow"
                                preload="auto"
                                poster={poster}
                                onCanPlayThrough={this.handleCanPlay}
                                onPlay={this.handlePlay}
                                onPause={this.handlePause}
                                onEnded={this.handleEnded}
                                onTimeUpdate={this.handleTimeUpdate}
                                onClick={this.play}
                                autoPlay={autoPlay || null}
                                onLoadedData={this.handleLoadedData}
                                src={videoUrl}>
                                不支持video
                            </video>
                            <div className="video-play-cover"
                                style={{display: (!playing || showPoint) ? "block" : "none"}}
                                onClick={this.play}>
                                <div className="video-play-cover-inner">
                                    {
                                        playing?
                                        <i className="iconfont icon-lull"></i>:
                                        <i className="iconfont icon-play"></i>
                                    }
                                </div>
                            </div>
                        </React.Fragment>
                    }
				</div>
                {
                    !isMobile &&
                    <div className="video-controls-box">
                        {duration ?
                            <Slider tipFormatter={null} onChange={this.changeSlider} value={currentTime * 1000} max={duration * 1000} />
                            : <Slider tipFormatter={null} value={0} />
                        }
                        <div className="video-controls-wrap">
                            <div className="video-controls-play">
                                <span className="video-controls-btn prev-btn" onClick={this.backward}>
                                    <i className="iconfont icon-left-play"></i>
                                </span>
                                <span className="video-controls-btn" onClick={this.play}>
                                    {
                                        playing?
                                        <i className="iconfont icon-lull"></i>:
                                        <i className="iconfont icon-play"></i>
                                    }
                                </span>
                                <span className="video-controls-btn next-btn" onClick={this.forward}>
                                    <i className="iconfont icon-right-play"></i>
                                </span>
                            </div>
                            <div className="video-controls-time">
                                {createTimeStr(currentTime)} / <span>{createTimeStr(duration)}</span>
                            </div>
                            <div className="video-controls-playback-rate">
                                <span onClick={this.changePlaybackRateModal} style={{
                                    color: themeColor || "#e81118",
                                    borderColor: themeColor || "#e81118"
                                }}>
                                    {`${playbackRate}X`}
                                </span>
                                {
                                    showPlaybackRate &&
                                    <div className="video-controls-rate-wrap">
                                        {
                                            rateArr.map((rate, index) =>
                                                <div className={`video-controls-rate-item${rate === playbackRate ? " active" : ""}`}
                                                    onClick={() => this.setVideoRate(rate)}
                                                    key={index}
                                                    style={{
                                                        color: rate === playbackRate ? themeColor || "#e81118" : "#fff"
                                                    }}
                                                >
                                                    {rate}X
                                                </div>
                                            )
                                        }
                                    </div>
                                }
                            </div>
                            {
                                isSupportFullScreen?
                                <div className="video-controls-full-screen">
                                    <span className="video-controls-btn" onClick={this.requestFullScreen}>
                                        {
                                            isFullScreen?
                                            <i className="iconfont icon-small-screen"></i>:
                                            <i className="iconfont icon-full-screen"></i>
                                        }
                                    </span>
                                </div> :null
                            }
                        </div>
                    </div>
                }
        	</div>
        )
    }
}


export default App;
